import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=559a7b20&scoped=true"
import script from "./CTA.vue?vue&type=script&lang=js"
export * from "./CTA.vue?vue&type=script&lang=js"
import style0 from "./CTA.vue?vue&type=style&index=0&id=559a7b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a7b20",
  null
  
)

export default component.exports